var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinanceBlockchain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Binance_Blockchain",
    "data-name": "Binance Blockchain",
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.949,
    height: 181,
    viewBox: "0 0 181.949 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1092",
    "data-name": "Rectangle 1092",
    width: 181,
    height: 181,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Binance-Icon-Logo.wine",
    d: "M40.879,90.5,20.465,110.914,0,90.5,20.414,70.086ZM90.5,40.879,125.517,75.9l20.414-20.414L90.5,0,35.017,55.483,55.431,75.9Zm70.035,29.207L140.121,90.5l20.414,20.414L180.949,90.5ZM90.5,140.121,55.483,105.1,35.069,125.517,90.5,181l55.431-55.483L125.517,105.1Zm0-29.207L110.914,90.5,90.5,70.086,70.035,90.5Z",
    transform: "translate(1)",
    fill: "#f0b90b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceBlockchain);
export default __webpack_public_path__ + "static/media/BinanceBlockchain.ec0e6670c286727014d6297a0a408bdb.svg";
export { ForwardRef as ReactComponent };